<script lang="ts">
	import { page } from '$app/stores';
	import type { Property } from '$lib/satellite.types';
	import { afterUpdate, onMount } from 'svelte';

	$: pixel = ($page.data.property as Property).fbPixel;

	type tcData = {
		eventStatus: 'tcloaded' | 'useractioncomplete';
		purpose: {
			consents: {
				3: boolean;
			};
		};
	};

	const init = () => {
		const w = window;

		if (w.fbq) {
			return;
		}

		w.fbq = function () {
			w.fbq.callMethod ? w.fbq.callMethod.apply(w.fbq, arguments) : w.fbq.queue.push(arguments);
		};

		if (!w._fbq) {
			w._fbq = w.fbq;
		}

		w.fbq.push = w.fbq;
		w.fbq.loaded = true;
		w.fbq.version = '2.0';
		w.fbq.queue = [];

		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://connect.facebook.net/en_US/fbevents.js';
		document.head.appendChild(script);

		w.fbq('consent', 'revoke');
		w.fbq('init', pixel);

		if (typeof w.__tcfapi === 'function') {
			w.__tcfapi('addEventListener', 2, (tcData: tcData, success: boolean) => {
				if (
					success &&
					(tcData?.eventStatus === 'tcloaded' || tcData?.eventStatus === 'useractioncomplete')
				) {
					if (tcData?.purpose?.consents?.[3]) {
						w.fbq('consent', 'grant');
					} else {
						w.fbq('consent', 'revoke');
					}
				}
			});
		}
	};

	afterUpdate(() => {
		window.fbq('track', 'PageView');
	});

	onMount(() => {
		init();
	});
</script>
